export default class authentified {
  constructor(token = {}) {
    this.id = token.nameid
    this.email = token.email
    this.userName = token.unique_name
    this.roles = token["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
    this.isAdmin = token.isAdmin != undefined && token.isAdmin == "true"
  }
}
